"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_ENRICHED_ATTRIBUTES = exports.DATE_COLUMNS = exports.CustomProductAttributes = exports.OriginalProductAttributes = exports.CATEGORY_DEFAULT_ENRICHED_ATTRIBUTES = exports.CATEGORY_DERIVED_LABEL_TAG_KEY = exports.LAST_ATTRIBUTE_UPDATED_AT_LABEL = exports.PRODUCT_ORIGINAL_CATEGORY_LABEL = exports.PRODUCT_CATEGORIES_LABEL = exports.CATEGORY_ATTRIBUTE_NAME = exports.CATEGORY_DERIVED_LABEL_DEFAULT = exports.PRODUCT_PAGE_URL_LABEL = exports.PRODUCT_SKU_LABEL = exports.PRODUCT_DESCRIPTION_LABEL = exports.PRODUCT_BRAND_LABEL = exports.PRODUCT_IMAGE_LABEL = exports.SpecialAttributeValueToLocalizationKey = exports.SpecialAttributeValue = void 0;
var SpecialAttributeValue;
(function (SpecialAttributeValue) {
    // Custom special attribute values that are not set by users but are used to represent specific cases in the UI.
    SpecialAttributeValue["Unknown"] = "Unknown";
    SpecialAttributeValue["NotInStrategy"] = "Not in Strategy";
    // Real special attribute value that can be set by users, so it should be kept unchanged
    SpecialAttributeValue["NotApplicable"] = "NOT APPLICABLE";
})(SpecialAttributeValue || (exports.SpecialAttributeValue = SpecialAttributeValue = {}));
exports.SpecialAttributeValueToLocalizationKey = {
    [SpecialAttributeValue.NotApplicable]: 'NOT_APPLICABLE',
    [SpecialAttributeValue.NotInStrategy]: 'NOT_STRATEGY',
    [SpecialAttributeValue.Unknown]: 'UNKNOWN',
};
// Enriched attribute names
exports.PRODUCT_IMAGE_LABEL = 'Product Image URL';
exports.PRODUCT_BRAND_LABEL = 'Brand';
exports.PRODUCT_DESCRIPTION_LABEL = 'Description';
exports.PRODUCT_SKU_LABEL = 'Product SKU';
exports.PRODUCT_PAGE_URL_LABEL = 'Product Page URL';
exports.CATEGORY_DERIVED_LABEL_DEFAULT = 'Product Type';
exports.CATEGORY_ATTRIBUTE_NAME = 'Classification Product Type';
exports.PRODUCT_CATEGORIES_LABEL = 'Categories';
// Original attribute names
exports.PRODUCT_ORIGINAL_CATEGORY_LABEL = 'category_names';
// product metadata
exports.LAST_ATTRIBUTE_UPDATED_AT_LABEL = 'lastAttributeUpdatedAt';
exports.CATEGORY_DERIVED_LABEL_TAG_KEY = 'ENRICH.CATEGORY_DERIVED_LABEL';
// there are some default Enriched attributes in each node that shouldn't be shown in the middle section
exports.CATEGORY_DEFAULT_ENRICHED_ATTRIBUTES = [
    exports.PRODUCT_PAGE_URL_LABEL,
    exports.PRODUCT_IMAGE_LABEL,
    exports.PRODUCT_DESCRIPTION_LABEL,
    exports.PRODUCT_SKU_LABEL,
];
var OriginalProductAttributes;
(function (OriginalProductAttributes) {
    OriginalProductAttributes["Description"] = "description";
    OriginalProductAttributes["Category"] = "category_names";
})(OriginalProductAttributes || (exports.OriginalProductAttributes = OriginalProductAttributes = {}));
var CustomProductAttributes;
(function (CustomProductAttributes) {
    CustomProductAttributes["Name"] = "name";
    CustomProductAttributes["LastAttributeUpdatedAt"] = "lastAttributeUpdatedAt";
    CustomProductAttributes["ExternalId"] = "externalId";
    CustomProductAttributes["ClassificationProductType"] = "category";
    CustomProductAttributes["CreatedAt"] = "createdAt";
    CustomProductAttributes["LastEditedBy"] = "lastEditedBy";
    CustomProductAttributes["LastReviewedBy"] = "lastReviewedBy";
})(CustomProductAttributes || (exports.CustomProductAttributes = CustomProductAttributes = {}));
exports.DATE_COLUMNS = [
    CustomProductAttributes.LastAttributeUpdatedAt,
    CustomProductAttributes.CreatedAt,
];
exports.BASE_ENRICHED_ATTRIBUTES = [exports.PRODUCT_IMAGE_LABEL, exports.PRODUCT_PAGE_URL_LABEL];
